const state = {
  noticeMessage: null,
  errorMessage: null,
  loadCompleted: false,
  isLoading: true,
  showGameWalletModal: false, // 存gameProviderId or false
  inGameId: null,
  leaveGamePath: '',
  confirmDialog: null,
  hideMobileNav: false
}

const mutations = {
  SET_LOAD_COMPLETED(state, data) {
    state.loadCompleted = data
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading
  },
  SET_NOTICE_MESSAGE(state, message) {
    state.noticeMessage = message
  },
  SET_GAME_WALLET_MODAL(state, data) {
    state.showGameWalletModal = data
  },
  SET_ERROR_MESSAGE(state, message) {
    state.errorMessage = message
  },
  SET_IN_GAME_ID(state, data) {
    state.inGameId = data
  },
  SET_LEAVE_GAME_PATH(state, data) {
    state.leaveGamePath = data
  },
  SET_CONFIRM_DIALOG(state, confirm) {
    state.confirmDialog = confirm
  },
  SET_ALERT(state, alert) {
    state.alert = alert
  },
  SET_HIDE_MOBILE_NAV(state, val) {
    state.hideMobileNav = val
  }
}

const actions = {}

export default {
  state,
  mutations,
  actions
}
